import { render } from "./PainelAdmin.vue?vue&type=template&id=5f9313d7&scoped=true"
import script from "./PainelAdmin.vue?vue&type=script&lang=js"
export * from "./PainelAdmin.vue?vue&type=script&lang=js"

import "./PainelAdmin.vue?vue&type=style&index=0&id=5f9313d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9313d7"]])

export default __exports__